module.exports = __webpack_public_path__ + "img/Improve_My_Store.cfe2d53a.svg";